import { useRef, useState, useLayoutEffect } from 'react';
import { Tag } from 'antd';

import { useWindowWidth } from 'hooks';
import { views } from 'components/Lists/constants';
import { format } from 'utils/date';

import Profile from './Profile';
import {
  ActionBar,
  OrgContainer,
  OrgTopContent,
  StatsContainer,
} from '../styled';
import Actions from '../Researcher/Actions';
import Stats from './Stats';
import Logo from './Logo';

const Result = props => {
  const { width, isMobile } = useWindowWidth();
  const statsRef = useRef();
  const actionBarRef = useRef();
  const [listsMaxWidth, setListsMaxWidth] = useState(null);

  useLayoutEffect(() => {
    if (isMobile || !statsRef.current || !actionBarRef.current) return;
    const statsLeft = statsRef.current.getBoundingClientRect().left;
    const barLeft = actionBarRef.current.getBoundingClientRect().left;
    setListsMaxWidth(statsLeft - barLeft);
  }, [width, isMobile]);

  return (
    <OrgContainer>
      <OrgTopContent>
        {!isMobile && <Logo {...props} />}
        <Profile {...props} />
        <StatsContainer ref={statsRef}>
          <Stats {...props} />
        </StatsContainer>
      </OrgTopContent>
      <ActionBar ref={actionBarRef} organisation>
        <Actions
          {...props}
          type={views.organisations}
          listsMaxWidth={listsMaxWidth}
        />
        {props.totalWorkItemMatches > 0 && props.lastActivityDate && (
          <Tag>Last matched activity {format(props.lastActivityDate)}</Tag>
        )}
      </ActionBar>
    </OrgContainer>
  );
};

export default Result;
